import { useQuery } from "@apollo/client";
import { Avatar, Button, Search, Spinner, Loader, Card } from "../../common";
import "./MergesIndex.css";
// import { SPORTS } from "../../../api/sports";
import { PROFILE_MERGES } from "../../../api/profileMerges";
import { Fragment } from "react";
import { useAppState } from "../../../utils/appState";
// import CreatePage from "../CreatePage";
import { useHistory } from "react-router-dom";
import moment from "moment";
import makeFileUrl from "../../../utils/makeFileUrl";

function getDateDiff(startDate, endDate) {
  const start = moment(startDate);
  const end = moment(endDate);

  const duration = moment.duration(end.diff(start));
  const hours = duration.asHours();
  const minutes = duration.asMinutes();
  const seconds = duration.asSeconds();
  if (minutes < 1) {
    return seconds.toFixed(2) + "s";
  }

  if (hours < 1) {
    return minutes.toFixed(2) + "m";
  }

  return hours.toFixed(2) + "h";
}

export default function MergesIndex() {
  const history = useHistory();
  const [, setAppState] = useAppState();
  const { loading, error, data, refetch, networkStatus, variables, fetchMore } =
    useQuery(
      PROFILE_MERGES({
        selectionSet: `
            createdAt
            updatedAt
            status
            cachedProfile
            profileToKeep{
                id
                name
                handle
                profilePhoto{
                    id
                    filename
                }
            }
            profileToDelete{
                id
                name
                handle
                profilePhoto{
                    id
                    filename
                }
            }
            uploadedBy{
                id
                name                
            }            
        `,
      }),
      {
        notifyOnNetworkStatusChange: true,
      }
    );

  if (error) {
    console.log(error);
    return <div>Error</div>;
  }

  const items = (data?.profileMerges || []).map((x) => ({
    ...x,
    cachedProfile: x.cachedProfile ? JSON.parse(x.cachedProfile) : "",
  }));
  console.log(items);

  return (
    <div className="App-index-page">
      <div className="App-index-page__header">
        <div className="App-index-page__header__title">Merges</div>
      </div>

      <div className="App-index-page__list" style={{ padding: "24px" }}>
        {networkStatus === 1 || networkStatus === 2 ? (
          <div className="App-index-page__list__loading">
            <Spinner />
          </div>
        ) : (
          <Fragment>
            {items.map((item) => (
              <Card className="upload-index-item" key={item.id}>
                <div className="upload-index-item__header">
                  <div className="upload-index-item__header__text">
                    PROFILE MERGE
                  </div>

                  <div className="upload-index-item__header__timestamp">
                    {moment(item.createdAt).format("DD/MM/YYYY h:mm A")}
                  </div>
                </div>

                <div className="upload-index-item__body">
                  <div className="upload-index-item__body__text-group">
                    <div className="upload-index-item__body__text-group__label">
                      Profile to keep
                    </div>

                    <div className="upload-index-item__body__text-group__value">
                      <div className="upload-index-item__body__text-group__value__img">
                        {item.profileToKeep?.profilePhoto && (
                          <Avatar media={item.profileToKeep?.profilePhoto} />
                        )}
                      </div>
                      <div className="upload-index-item__body__text-group__value__text">
                        {item.profileToKeep.name} (@{item.profileToKeep.handle})
                      </div>
                    </div>
                  </div>

                  <div className="upload-index-item__body__text-group">
                    <div className="upload-index-item__body__text-group__label">
                      Profile to delete
                    </div>

                    <div className="upload-index-item__body__text-group__value">
                      <div className="upload-index-item__body__text-group__value__img">
                        {item.cachedProfile?.profilePhoto && (
                          <Avatar
                            media={{
                              filename: item.cachedProfile?.profilePhoto,
                            }}
                          />
                        )}
                      </div>
                      <div className="upload-index-item__body__text-group__value__text">
                        {item.cachedProfile?.name} (@
                        {item.cachedProfile?.handle})
                      </div>
                    </div>
                  </div>

                  <div className="upload-index-item__body__text-group">
                    <div className="upload-index-item__body__text-group__label">
                      Initiated By
                    </div>

                    <div className="upload-index-item__body__text-group__value">
                      {item.uploadedBy?.name || "Unknown"}
                    </div>
                  </div>

                  <div className="upload-index-item__body__text-group">
                    <div className="upload-index-item__body__text-group__label">
                      Status
                    </div>

                    <div className="upload-index-item__body__text-group__value">
                      {item.status}
                    </div>
                  </div>

                  <div className="upload-index-item__body__text-group">
                    <div className="upload-index-item__body__text-group__label">
                      Duration
                    </div>

                    <div className="upload-index-item__body__text-group__value">
                      {getDateDiff(item.createdAt, item.updatedAt)}
                    </div>
                  </div>
                </div>
              </Card>
            ))}

            {!!items.length && (
              <div
                className="App-index-page__list__item"
                onClick={() => {
                  fetchMore({
                    variables: {
                      ...variables,
                      cursor: items[items.length - 1].id,
                    },
                  });
                }}
                style={{ alignItems: "center", justifyContent: "center" }}
              >
                <div className="App-index-page__list__item__text">
                  <div className="App-index-page__list__item__text__secondary">
                    {networkStatus === 3 ? (
                      <Loader theme={"small grey"} />
                    ) : (
                      "Load More"
                    )}
                  </div>
                </div>
              </div>
            )}
          </Fragment>
        )}
      </div>
    </div>
  );
}
